import React from 'react';
import ReactDOM from 'react-dom';
import Form from './Form';
// import 'bootstrap/dist/css/bootstrap.min.css';

const container = document.querySelector('.prospektbestellung');
if (container) {
  ReactDOM.render(<Form />, container);
} else {
  console.error('Prospektbestellung nicht gefunden!');
}

